<template>
  <div :style="ImageUrl" class="circular-150 cover-background" v-if="!isShowDefalut"></div>
  <div v-else class="circular-150 cover-background icon-user-circle"></div>
</template>

<script>
export default {
  props: ['imageName', 'isShowDefalut'],
  computed: {
    ImageUrl() {
      return {
        'background-image': `url(${this.$store.getters.AppConfig.Urls.ContentAssetsBaseUrl + this.imageName})`
      }
    }
  }
}
</script>
<style scoped>
  .circular-150 {
    width: 5em;
    height: 5em;
    border-radius: 3em;
    -webkit-border-radius: 3em;
    -moz-border-radius: 3em;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/CircularImage.vue